import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";

const { Text, Title } = Typography;

const ManageGlobalConfigurations = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [codeList, setCodeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const columns = [
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: labelConfig.enabled,
      dataIndex: "enabled",
      sorter: (a, b) => a["enabled"].localeCompare(b["enabled"]),
      render: (_, record) => {
        return <Text> {handleFlgStatus(record?.enabled, {}, true)}</Text>;
      },
    },
    {
      title: labelConfig.value,
      dataIndex: "value",
      sorter: (a, b) => a["value"].localeCompare(b["value"]),
    },
    {
      title: labelConfig.stringValue,
      dataIndex: "stringValue",
      sorter: (a, b) => a["stringValue"].localeCompare(b["stringValue"]),
    },
  ];

  useEffect(() => {
    getConfigurationsList();
  }, []);

  const getConfigurationsList = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Configurations, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.globalConfiguration;
        let tempConfigurationsList = [];

        objList.forEach((element) => {
          tempConfigurationsList.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            enabled: element?.enabled ? "True" : "False",
            stringValue:
              element?.stringValue || element.stringValue === 0 ? element?.stringValue : "-",
            value: element?.value || element.value === 0 ? element?.value : "-",
          });
        });

        setCodeList(tempConfigurationsList);
        setOriginalList(tempConfigurationsList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Configurations, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.globalConfiguration;
          let tempConfigurationsList = [];

          objList.forEach((element) => {
            tempConfigurationsList.push({
              key: element?.id,
              id: element?.id,
              name: element?.name ? element?.name : "-",
              enabled: element?.enabled ? "True" : "False",
              stringValue:
                element?.stringValue || element.stringValue === 0 ? element?.stringValue : "-",
              value: element?.value || element.value === 0 ? element?.value : "-",
            });
          });

          resolve(tempConfigurationsList);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRowKeys(selectedKeys);
    setSelectedRow(objParam[0]);
    console.log(objParam[0]);
    console.log(objParam[0].enabled);

    if (objParam[0].enabled.toLowerCase() === "false") {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      [
        BOM.HasPermission("UPDATE_CONFIGURATION") && cnt.RIGHT_EDIT_BTN,
        BOM.HasPermission("UPDATE_CONFIGURATION") && cnt.RIGHT_APPROVE_BTN,
      ].map((item) => {
        dispatch({
          type: item,
        });
      });
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      [
        BOM.HasPermission("UPDATE_CONFIGURATION") && cnt.RIGHT_EDIT_BTN,
        BOM.HasPermission("UPDATE_CONFIGURATION") && cnt.RIGHT_REJECT_BTN,
      ].map((item) => {
        dispatch({
          type: item,
        });
      });
    }
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setCodeList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey?.toLowerCase()),
    );
    setCodeList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-config", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }
  const handleOnEnable = () => {
    let action = "Confirm Enable ";
    let name = `${selectedRow.name}`;

    // console.log(selectedRow);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);

        const url = `${apiConfig.Configurations}/${selectedRow.id}`;
        const body = {
          enabled: "true",
          method: "PUT",
          session,
        };

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Configuration Enabled");
            // navigate("/sms0802");
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });

            // rightAction(cnt.RIGHT_SEARCH_BTN);

            getConfigurationsList();
            //STOP LOAD
            // Clear selection after successful approval
            setSelectedRowKeys([]);
            setSelectedRow([]);
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      },
    );
  };

  const handleOnDisable = () => {
    let action = "Confirm Disable ";
    let name = `${selectedRow.name}`;

    // console.log(selectedRow);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);

        const url = `${apiConfig.Configurations}/${selectedRow.id}`;
        const body = {
          enabled: "false",
          method: "PUT",
          session,
        };

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Configuration Disabled");
            // navigate("/sms0802");
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });

            // rightAction(cnt.RIGHT_SEARCH_BTN);

            getConfigurationsList();
            //STOP LOAD
            // Clear selection after successful approval
            setSelectedRowKeys([]);
            setSelectedRow([]);
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      },
    );
  };

  const handleFlgStatus = (status, style = {}, isListing = false) => {
    switch (status.toLowerCase()) {
      case "true":
        return (
          <Tag
            // icon={<CheckCircleOutlined />}
            color={`${isListing ? "success" : "#87D068"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      case "false":
        return (
          <Tag
            // icon={<CloseCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      default:
        return (
          <Tag
            // icon={<ClockCircleOutlined />}
            color={`${isListing ? "warning" : "#FFEB86"}`}
            style={{ color: "black", ...style }}
          >
            {BOM.SubstringFormat(status, 21)}
          </Tag>
        );
    }
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnEnable()}
      onReject={() => handleOnDisable()}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageConfigurations}
        pageItems={staticConfig.manageConfigurationsItems}
      />

      <Card
        title={`${labelConfig.configuration} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={codeList}
              columns={columns}
              fileName={"Configuration List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              selectedRowKeys: selectedRowKeys, // Controlled selection
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={codeList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageGlobalConfigurations);
